import { exists } from '@/helpers/utilities';

export default class SliderNav {
    constructor(node, numSteps) {
        this.node = node;
        this.maxStep = numSteps;
        this.dots = null;

        this.nodeExists = exists(this.node);
        if (!this.nodeExists) return;

        this.init();
    }

    getDots() {
        this.dots = this.node.children;
    }

    update(step) {
        if (typeof step == 'undefined' || step == null) return;
        if (!this.dots.length) return;

        window.requestAnimationFrame(() => {
            [...this.dots].map((dot) => {
                dot.classList.remove('js-is-active');
            });

            this.dots[step].classList.add('js-is-active');
        });
    }

    init() {
        this.getDots();
    }
}
